export enum PjmBatteryChemistryType {
    LEAD_ACID = 'LEAD_ACID',
    LITHIUM_AIR = 'LITHIUM_AIR',
    LITHIUM_ION = 'LITHIUM_ION',
    LITHIUM_METAL = 'LITHIUM_METAL',
    LITHIUM_SULFUR = 'LITHIUM_SULFUR',
    MAGNESIUM_ION = 'MAGNESIUM_ION',
    MAGNESIUM_LITHIUM_HYBRID = 'MAGNESIUM_LITHIUM_HYBRID',
    ORGANIC_AQUEOUS_FLOW = 'ORGANIC_AQUEOUS_FLOW',
    SODIUM_ION = 'SODIUM_ION',
    SODIUM_METAL_HALIDE = 'SODIUM_METAL_HALIDE',
    VANADIUM_REDOX_FLOW = 'VANADIUM_REDOX_FLOW',
    ZINC_ION = 'ZINC_ION',
    ZINC_MANGANESE_OXIDE = 'ZINC_MANGANESE_OXIDE',
    ZINC_POLYIODIDE_FLOW = 'ZINC_POLYIODIDE_FLOW',
}

export enum PjmBatteryType {
    ELECTRIC_VEHICLE = 'ELECTRIC_VEHICLE',
    PV_SYSTEM = 'PV_SYSTEM',
    STAND_ALONE = 'STAND_ALONE',
}

export enum PjmMeterType {
    CSP_METER = 'CSP_METER', // Curtailment Service Providers - virtual meter
    EDC_METER = 'EDC_METER', // Electric Distribution Company - normal/real meter
}

export enum PjmMeterEquipmentStatus {
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    PENDING = 'PENDING',
}

export enum PjmInterval {
    MINUTE = 'MINUTE',
    HOURLY = 'HOURLY',
    TELEMETRY = 'TELEMETRY',
    OTHER = 'OTHER',
}

export enum PjmRerraStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum PjmLocationStatus {
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    INACTIVE = 'INACTIVE',
    NEW = 'NEW',
}

export enum PjmResidentialProgramType {
    DLC = 'DLC',
    BEHAVIOR_INCENTIVE = 'BEHAVIOR_INCENTIVE',
    BEHAVIOR_PENALTY = 'BEHAVIOR_PENALTY',
}

export enum PjmLoadReductionType {
    BATTERIES = 'BATTERIES',
    GENERATOR = 'GENERATOR',
    HVAC = 'HVAC',
    LIGHTING = 'LIGHTING',
    MANUFACTURING = 'MANUFACTURING',
    PLUG_LOAD = 'PLUG_LOAD',
    REFRIGERATION = 'REFRIGERATION',
    WATER_HEATERS = 'WATER_HEATERS',
    COMPUTING = 'COMPUTING',
}

export enum PjmGeneratorType {
    'None' = 'None',
    'Internal Combustion Engine' = 'Internal Combustion Engine',
    'Combustion Turbines' = 'Combustion Turbines',
    'Steam Engines and Cogeneration Units' = 'Steam Engines and Cogeneration Units',
}

export enum PjmGeneratorFuelType {
    'None' = 'None',
    'Coal' = 'Coal',
    'Diesel' = 'Diesel',
    'Natural Gas' = 'Natural Gas',
    'Oil' = 'Oil',
    'Gasoline' = 'Gasoline',
    'Kerosene' = 'Kerosene',
    'Propane' = 'Propane',
    'Wood' = 'Wood',
    'Landfill Gases' = 'Landfill Gases',
    'Waste Products' = 'Waste Products',
}

export enum PjmGeneratorPermitStatus {
    AVAILABLE = 'AVAILABLE',
    IN_PROGRESS = 'IN_PROGRESS',
    NONE = 'NONE',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum PjmGeneratorPermitType {
    EMERGENCY_ONLY = 'EMERGENCY_ONLY',
    NON_EMERGENCY = 'NON_EMERGENCY',
    NONE = 'NONE',
}

export enum PjmAgreementType {
    NONE = 'NONE',
    WMPA = 'WMPA',
    ISA = 'ISA',
    NEM_OTHER = 'NEM_OTHER',
}

/**
 * Different program requires different configuration
 * so not sure if we need to support all of them
 * As in the DRHUB UI we have only registrations for
 * Load Management DR Full - we will use only it for now
 */
export enum PjmRegistrationProgram {
    'Economic' = 'Economic',
    'Load Management DR Full' = 'Load Management DR Full',
    'Load Management DR Capacity Only' = 'Load Management DR Capacity Only',
    'Emergency Energy Only' = 'Emergency Energy Only',
    'Price Responsive Demand' = 'Price Responsive Demand',
    'Peak Shaving Adjustment' = 'Peak Shaving Adjustment',
}

export enum PjmRegistrationStatus {
    CONFIRMED = 'Confirmed',
    CONFIRMED_EXTENSION = 'Confirmed-Extension',
    DENIED = 'Denied',
    NEW = 'New',
    PENDING_PJM = 'Pending',
    TERMINATED = 'Terminated',
    TERMINATED_DUPLICATE = 'Terminated-Duplicate',
    WITHDRAWN = 'Withdrawn',
}

export enum PjmRegistrationInputStatus {
    APPROVED = 'APPROVED',
    APPROVED_AS_MODIFIED = 'APPROVED_AS_MODIFIED',
    DENIED = 'DENIED',
    NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
    PENDING = 'PENDING',
    WITHDRAWN = 'WITHDRAWN',
}

export enum PjmSrAreaType {
    MAD = 'MAD',
    RTO = 'RTO',
}

export enum PjmMeasurementMethod {
    FIRM_SERVICE_LEVEL = 'FIRM_SERVICE_LEVEL',
    GUARANTEED_LOAD_DROP = 'GUARANTEED_LOAD_DROP',
    GUARANTEED_LOAD_DROP_BYGEN = 'GUARANTEED_LOAD_DROP_BYGEN',
    MESL = 'MESL',
    PILOT = 'PILOT',
}

export enum PjmProductType {
    BASE_DR = 'BASE_DR',
    CAPACITY_PERFORMANCE_DR = 'CAPACITY_PERFORMANCE_DR',
    LIMITED_DR = 'LIMITED_DR',
    EXTENDED_SUMMER_DR = 'EXTENDED_SUMMER_DR',
    ANNUAL_DR = 'ANNUAL_DR',
    PRICE_RESPONSIVE_DEMAND = 'PRICE_RESPONSIVE_DEMAND',
}

export enum PjmResourceType {
    EMERGENCY = 'EMERGENCY',
    PRE_EMERGENCY = 'PRE_EMERGENCY',
}

export enum PjmRetailRateType {
    DAY_AHEAD_LMP = 'DAY_AHEAD_LMP',
    FIXED_PRICE = 'FIXED_PRICE',
    REAL_TIME_LMP = 'REAL_TIME_LMP',
    OTHER = 'OTHER',
}

export enum PjmRegistrationLeadTime {
    Quick_30 = 'Quick_30',
    Short_60 = 'Short_60',
    Long_120 = 'Long_120',
}

export enum PjmMarket {
    CAP = 'CAP',
    EEO = 'EEO',
    ENERGY = 'ENERGY',
    'ENERGY,REG' = 'ENERGY,REG',
    'ENERGY,REG,SR' = 'ENERGY,REG,SR',
    'ENERGY,REG,SR,SECR' = 'ENERGY,REG,SR,SECR',
    'ENERGY,SR' = 'ENERGY,SR',
    'ENERGY,SR, DASR' = 'ENERGY,SR, DASR',
    'N/A' = 'N/A',
    PRD = 'PRD',
    PSA = 'PSA',
    REG = 'REG',
    SR = 'SR',
}
